import { Component, computed, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { AinFormFieldComponent } from '../../../shared/design-system/form-field.component';
import { LocalizedText, readLocalizedText, writeLocalizedText } from '../../../shared/dynamic-form/form-schema.models';
import { FormBuilderEditCultureService } from './form-builder-edit-culture.service';

@Component({
  standalone: true,
  selector: 'ain-form-builder-localized-input',
  imports: [FormsModule, InputTextModule, TextareaModule, AinFormFieldComponent],
  template: `
    <ain-form-field [label]="label()">
      <span class="culture-badge" [attr.aria-label]="cultureBadge()">{{ cultureBadge() }}</span>
      @if (multiline()) {
        <textarea
          pTextarea
          [rows]="rows()"
          [ngModel]="value()"
          [disabled]="disabled()"
          [attr.aria-label]="label()"
          (ngModelChange)="onChange($event)"></textarea>
      } @else {
        <input
          pInputText
          [ngModel]="value()"
          [disabled]="disabled()"
          [attr.aria-label]="label()"
          (ngModelChange)="onChange($event)" />
      }
    </ain-form-field>
  `,
  styles: [`
    :host { display: block; }
    .culture-badge {
      display: inline-block;
      margin-block-end: 4px;
      padding: 2px 8px;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 600;
      background: #e2e8f0;
      color: #334155;
    }
  `]
})
export class FormBuilderLocalizedInputComponent {
  private readonly editCultureService = inject(FormBuilderEditCultureService);

  readonly label = input.required<string>();
  readonly text = input<LocalizedText | string | undefined | null>();
  readonly multiline = input(false);
  readonly rows = input(2);
  readonly disabled = input(false);

  readonly textChange = output<LocalizedText>();

  readonly value = computed(() =>
    readLocalizedText(this.text(), this.editCultureService.editCulture())
  );

  readonly cultureBadge = computed(() =>
    this.editCultureService.editCulture() === 'fa-IR' ? 'FA' : 'EN'
  );

  onChange(value: string): void {
    this.textChange.emit(writeLocalizedText(this.text(), this.editCultureService.editCulture(), value));
  }
}
